import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import axios from "axios";
import Card from "../../Components/Cards/Card";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import swal from 'sweetalert';
import useDealOfTheDay from "./useDealOfTheDay";

export default function () {
  const { reset, handleSubmit, dealOfTheDayFields, setData, setErrors } = useDealOfTheDay();
  const {id} = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`product-lists/${id}/edit`).then(res => {
      if(res.data.status === 'success'){
        setData(res.data)
        reset(res.data.deal_of_the_day);
      }
    });
  }, []);

  const edit = data => {
    axios.put(`product-lists/${id}`, data)
      .then(function (res) {
        if (res.status == 200) {
          swal('List has been updated successfully!', {
            icon: "success",
          });
          navigate("/deal-of-the-day");
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.errors || {});
        }
      });
  }

  return (
    <Card title="Edit deal of the day product">
      <form className="form w-100 row" onSubmit={handleSubmit(edit)}>

        {dealOfTheDayFields}

        <SubmitButton
          title="Save"
          classes="w-auto d-inline-block mt-4"
        />
      </form>
    </Card>
  );
}